<svg
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 64 64"
  (click)="openDialog()"
>
  <path
    d="M29.75,31.81,9.43,20.08c-.74-.43-1.35-.08-1.35.77L8,44.2a2.94,2.94,0,0,0,1.34,2.32L29.67,58.25c.74.43,1.35.08,1.35-.77l.07-23.34A3,3,0,0,0,29.75,31.81ZM12.61,29.92a4.8,4.8,0,0,1-2.17-3.76c0-1.38,1-1.94,2.19-1.25a4.82,4.82,0,0,1,2.17,3.77C14.79,30.06,13.82,30.62,12.61,29.92Zm6.93,12a4.8,4.8,0,0,1-2.17-3.76c0-1.38,1-1.94,2.19-1.25a4.82,4.82,0,0,1,2.17,3.77C21.73,42,20.75,42.59,19.54,41.89Zm6.94,11.53a4.76,4.76,0,0,1-2.17-3.77c0-1.37,1-1.94,2.18-1.24a4.75,4.75,0,0,1,2.17,3.76C28.66,53.55,27.68,54.12,26.48,53.42Z"
  />
  <path
    d="M56.07,44.22,56,20.88c0-.86-.6-1.2-1.34-.78L34.34,31.84A2.94,2.94,0,0,0,33,34.16l.06,23.34c0,.85.61,1.2,1.35.77L54.73,46.54A3,3,0,0,0,56.07,44.22Zm-11.53-2.3c-1.2.69-2.18.13-2.18-1.25a4.78,4.78,0,0,1,2.17-3.77c1.2-.69,2.18-.13,2.19,1.25A4.82,4.82,0,0,1,44.54,41.92Z"
  />
  <path
    d="M10.28,16.87a.83.83,0,0,0,0,1.56L30.6,30.16a3,3,0,0,0,2.69,0L53.47,18.43a.83.83,0,0,0,0-1.56L33.14,5.14a3,3,0,0,0-2.68,0Zm24,9.94a4.83,4.83,0,0,1-4.35,0c-1.2-.7-1.21-1.83,0-2.52a4.83,4.83,0,0,1,4.35,0A1.33,1.33,0,0,1,34.32,26.81ZM33.77,8.49a1.33,1.33,0,0,1,0,2.52,4.81,4.81,0,0,1-4.34,0c-1.2-.7-1.21-1.83,0-2.52A4.77,4.77,0,0,1,33.77,8.49Z"
  />
</svg>
